<template>
  <div class="dropdown-button">
    <div class="dropdown-icon" @click="toggleDropdown">
      <IconBase icon-name="actions" iconColor="#222" viewBox="0 0 512.064 512.064" width="100%" height="100%" strokeWidth="0px"><IconMessengerNotifications /></IconBase>
    </div>
    <div v-if="messengerIndicator" class="indicator"></div>
    <MessengerNotifications v-if="dropDownOpen" :userID="userID" @openConversation="openConversation" @openMessenger="openMessenger" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import IconBase from "@/components/IconBase.vue";
import IconMessengerNotifications from "@/components/SVG/IconMessengerNotifications";
import messengerSocket from "../../../socket/messengerSocket";
import CloseComponent from "@/mixins/CloseComponent";
import MessengerNotifications from "./MessengerNotifications";
import messengerAPI from "@/api/messengerAPI";
import TasksStore from "./TasksStore.js";

export default {
  name: "MessengerNotificationsButton",
  mixins: [CloseComponent],
  data() {
    return {
      gettingConversation: false,
      fetchError: false,
    };
  },
  components: {
    IconBase,
    IconMessengerNotifications,
    MessengerNotifications,
  },
  computed: {
    ...mapState({
      userID: (state) => state.auth.user._id,
      messengerIndicator: (state) => state.indicators.messenger,
      oldestLoadedDateMS: (state) => state.messages.oldestLoadedDateMS,
      allConvoPreviewsLoaded: (state) => state.messages.allConvoPreviewsLoaded,
    }),
    dropDownOpen() {
      return this.componentOpen; /* from mixin */
    },
  },
  methods: {
    async toggleDropdown() {
      TasksStore.methods.closeTasks();
      /* If mobile, just open Messenger */
      if (this.$windowWidth < 909) {
        await this.loadMoreConversations();
        this.openMessenger(true);
      } else {
        /* wrapper for mixin */
        this.toggleComponent();
      }
      if (this.messengerIndicator) {
        messengerSocket.setMessagesAsSeen();
      }
    },
    openConversation(conversationID) {
      this.openMessenger();
      this.$store.dispatch("messages/setCurrentConversation", conversationID);
      /* In case dropdown was open whilst receiving a new message
      and then user clicks on a conversation, and the indicator
      is still on, ensure it gets turned off. */
      if (this.messengerIndicator) {
        messengerSocket.setMessagesAsSeen();
      }
      this.componentOpen = false; // from mixin, close dropdown
    },
    openMessenger(resetCurrentConvo) {
      if (resetCurrentConvo) {
        this.$store.dispatch("messages/setCurrentConversation", "");
      }
      this.componentOpen = false; // from mixin, close dropdown
      this.$store.commit("messages/SET_MODAL_OPENED", true);
      window.mixpanel.track("Open Messenger");
    },
    async loadMoreConversations() {
      const NR_CONVOS_TO_LOAD = 4;
      const result = await messengerAPI.getConversations(this.oldestLoadedDateMS, 0, NR_CONVOS_TO_LOAD);
      if (result !== null) {
        await this.$store.dispatch("messages/addConversations", {
          userID: this.userID,
          conversations: result.conversations,
        });
        if (result.allLoaded) {
          this.$store.commit("messages/SET_ALL_CONVOS_LOADED", true);
        }
      } else {
        console.error("HAHA FAIL no previews for youuuu ");
      }
    },
  },
};
</script>

<style scoped>
@import "./styles/DropdownButton.css";
</style>
